import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ColorTile from './ColorTile'
import HexInput from './HexInput'

import {
	StyledSliderPicker,
	StyledColorSlider,
	StyledColorControlPanel,
	StyledLeftBlock, StyledColorControlBlock
} from './styled'

const ColorControllers = ({ togglePicker, selectColor, formColor }) => {
	const [exampleColor, setExampleColor] = useState(formColor)
	const onChangeComplete = color => {
		setExampleColor(color.hex)
	}
	return (
		<StyledColorControlPanel>
			<StyledLeftBlock>
				<ColorTile isExample={true} setExampleColor={setExampleColor} color={exampleColor} togglePicker={togglePicker}
									 selectColor={selectColor}/>
				<HexInput value={exampleColor} setExampleColor={setExampleColor} />
			</StyledLeftBlock>
			<StyledColorControlBlock>
				<StyledSliderPicker>
					<StyledColorSlider color={exampleColor || ''} onChangeComplete={onChangeComplete}/>
				</StyledSliderPicker>
			</StyledColorControlBlock>
		</StyledColorControlPanel>
	)
}

ColorControllers.propTypes = {
	formColor: PropTypes.string,
	togglePicker: PropTypes.func,
	selectColor: PropTypes.func
}

export default ColorControllers
